"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOption = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
exports.SelectOption = function (props) {
    var option = props.option, isSelected = props.isSelected;
    var toRender;
    if (option.label) {
        toRender = option.label;
    }
    else if (react_2.isValidElement(option.item)) {
        // If item can be rendered, then prefer that
        toRender = option.item;
    }
    else {
        // Otherwise fall back to value
        toRender = option.value;
    }
    if (props.multiple) {
        return (react_1.default.createElement("label", { className: "c-label u-font-regular" },
            props.multiple && (react_1.default.createElement("input", { className: "c-input", type: "checkbox", checked: isSelected, readOnly: true })),
            toRender));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null, toRender);
    }
};
//# sourceMappingURL=SelectOption.js.map